import { Component, Input, OnInit, inject } from '@angular/core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';

@Component({
    selector: 'app-withdraw-simpan',
    templateUrl: './withdraw-simpan.component.html',
    styleUrls: ['./withdraw-simpan.component.scss'],
    standalone: false
})
export class WithdrawSimpanComponent implements OnInit {
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @Input() totalReserveAmount: number;
  @Input() selectedProfileID: number;
  withdrawAmount: number;
  selectedAccountId: number;
  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];

  paymentDate: Date = new Date();
  disabledSubmit = false;

  ngOnInit(): void {
    const companyId = Number(sessionStorage.getItem('companyId'));
    this.getAllAccountsOfCompany(companyId);
  }

  checkSimpanLeftEnough() {
    if (this.calculateReserveLeft() < 0)
      return false;
    else
      return true;
  }

  private getAllAccountsOfCompany(companyId: number) {
    const loggedInUsername = sessionStorage.getItem("username");
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          if (account.Username == undefined)
            this.companyBankAccountList.push(account);
          else if (account.Username == loggedInUsername)
            this.cashAccountList.push(account);
        });
      }
    };
  }

  submit() {
    if (this.withdrawAmount == undefined)
      this.sharedService.openAlert("Please fill in the withdrawal amount", ALERT_TYPE.DANGER);
    else
      this.withdrawWithReserve();
  }

  withdrawWithReserve() {
    this.disabledSubmit = true;

    const extras = [{ "amount": this.withdrawAmount }]
    const data = {
      "extras": extras,
      "accountId": Number(this.selectedAccountId),
      "dateCreated": this.paymentDate,
      "reserve": -this.withdrawAmount,
      "remark": "Simpan withdraw Duit Lebih"
    };

    const xhr = this.restapi.postRequest(this.constructApi.getWithdrawReserve(this.selectedProfileID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          this.sharedService.openAlert("Successfully withdraw reserve!", ALERT_TYPE.SUCCESS);
          window.location.reload();
        }
        else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }


  calculateReserveLeft() {
    return this.totalReserveAmount - this.withdrawAmount;
  }
}
